import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-bearbeiten-berechtigung-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenDokumentBearbeitenBerechtigungHinzufuegenEffects {

    DokumentBearbeitenBerechtigungHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_BEARBEITEN_BERECHTIGUNG_HINZUFUEGEN),
        mergeMap((x: ac.PostDokumentBearbeitenBerechtigungHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentBearbeitenBerechtigungHinzufuegen(x.dokumentBerechtigungRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentBearbeitenBerechtigungHinzufuegenErfolgreichAction(result, x.dokumentBerechtigungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentBearbeitenBerechtigungHinzufuegenFehlerAction(error, x.dokumentBerechtigungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumenteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumenteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumenteCommandService);
        }
        return this.service;
    }
}
